<template>
  <pt-banner-detail class="pt-banner-detail__page" :position="position" :id="id"></pt-banner-detail>
</template>

<script>
import PtBannerDetail from 'cps/mall-manage/recommend-manage/pt-banner-manage/pt-banner-detail/withData'
export default {
  name: 'pt-banner-detail__view',
  components: {
    'pt-banner-detail': PtBannerDetail
  },
  props: {
    position: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
